import { HttpErrorResponse } from '@angular/common/http';

export class LoginAuthenticationError extends Error {
  constructor(public originalError: HttpErrorResponse) {
    super('Interactive login authentication failed.');
    this.name = 'LoginAuthenticationError';
    Object.setPrototypeOf(this, LoginAuthenticationError.prototype);
  }
}
